module.exports = __webpack_public_path__ + "static/img/logo.be5f9de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 19